/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  QueuesZerocost,
  QueuesZerocostInterface,
  QueuesConstructor,
} from "../QueuesZerocost";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "methods",
            type: "address",
          },
          {
            internalType: "address",
            name: "restricted",
            type: "address",
          },
          {
            internalType: "address",
            name: "queues",
            type: "address",
          },
          {
            internalType: "address",
            name: "zerocost",
            type: "address",
          },
          {
            internalType: "address",
            name: "arenas",
            type: "address",
          },
          {
            internalType: "address",
            name: "hounds",
            type: "address",
          },
          {
            internalType: "address",
            name: "payments",
            type: "address",
          },
          {
            internalType: "address",
            name: "races",
            type: "address",
          },
          {
            internalType: "address",
            name: "raceUploader",
            type: "address",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
        ],
        internalType: "struct QueuesConstructor.Struct",
        name: "input",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "control",
    outputs: [
      {
        internalType: "address",
        name: "methods",
        type: "address",
      },
      {
        internalType: "address",
        name: "restricted",
        type: "address",
      },
      {
        internalType: "address",
        name: "queues",
        type: "address",
      },
      {
        internalType: "address",
        name: "zerocost",
        type: "address",
      },
      {
        internalType: "address",
        name: "arenas",
        type: "address",
      },
      {
        internalType: "address",
        name: "hounds",
        type: "address",
      },
      {
        internalType: "address",
        name: "payments",
        type: "address",
      },
      {
        internalType: "address",
        name: "races",
        type: "address",
      },
      {
        internalType: "address",
        name: "raceUploader",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "getEnqueueCost",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct MicroPayment.Struct",
        name: "",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct MicroPayment.Struct",
        name: "",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct MicroPayment.Struct",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "methods",
            type: "address",
          },
          {
            internalType: "address",
            name: "restricted",
            type: "address",
          },
          {
            internalType: "address",
            name: "queues",
            type: "address",
          },
          {
            internalType: "address",
            name: "zerocost",
            type: "address",
          },
          {
            internalType: "address",
            name: "arenas",
            type: "address",
          },
          {
            internalType: "address",
            name: "hounds",
            type: "address",
          },
          {
            internalType: "address",
            name: "payments",
            type: "address",
          },
          {
            internalType: "address",
            name: "races",
            type: "address",
          },
          {
            internalType: "address",
            name: "raceUploader",
            type: "address",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
        ],
        internalType: "struct QueuesConstructor.Struct",
        name: "globalParameters",
        type: "tuple",
      },
    ],
    name: "setGlobalParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type QueuesZerocostConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: QueuesZerocostConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class QueuesZerocost__factory extends ContractFactory {
  constructor(...args: QueuesZerocostConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "QueuesZerocost";
  }

  deploy(
    input: QueuesConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<QueuesZerocost> {
    return super.deploy(input, overrides || {}) as Promise<QueuesZerocost>;
  }
  getDeployTransaction(
    input: QueuesConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(input, overrides || {});
  }
  attach(address: string): QueuesZerocost {
    return super.attach(address) as QueuesZerocost;
  }
  connect(signer: Signer): QueuesZerocost__factory {
    return super.connect(signer) as QueuesZerocost__factory;
  }
  static readonly contractName: "QueuesZerocost";
  public readonly contractName: "QueuesZerocost";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): QueuesZerocostInterface {
    return new utils.Interface(_abi) as QueuesZerocostInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): QueuesZerocost {
    return new Contract(address, _abi, signerOrProvider) as QueuesZerocost;
  }
}
